// ------------------------------------
// Create Organization
// ------------------------------------

export const API_VALIDATE_ORGANIZATION_NAME = 'validate/domain-name/';
export const API_JOIN_ON_INVITE = 'invite/confirm/';

// ------------------------------------
// Create Organization
// ------------------------------------

export const API_REGISTRATION = 'registration/';
export const API_APPLY_REGISTRATION_EMAIL = `${API_REGISTRATION}apply/`;
export const API_VERIFY_EMAIL = `${API_REGISTRATION}verify-email/`;
export const API_REGISTRATION_UPDATE = `${API_REGISTRATION}update/`;
export const API_REGISTRATION_CONFIRM = `${API_REGISTRATION}confirm/`;

// ------------------------------------
// Credentials
// ------------------------------------

export const API_LOGIN = 'auth/login/';
export const API_ME = 'auth/me/';
export const API_REQUEST_RESET_PASSWORD = 'reset-password/';
export const API_RESET_PASSWORD = 'auth/password/reset/confirm/';

// ------------------------------------
// 2FAuthentication
// ------------------------------------

export const API_2FA_INITIATE = 'auth/2fa/initiate/';
export const API_2FA_VERIFY = 'auth/2fa/verify/';
export const API_2FA_LOGIN = 'auth/2fa/login/';
export const API_2FA_DEACTIVATE = 'auth/2fa/deactivate/';

// ------------------------------------
// Users
// ------------------------------------

export const API_USERS = 'users/';
export const API_USERS_BASIC = `${API_USERS}basic/`;
export const API_USER_FIELD_CONFIG = `${API_USERS}profile-fields/`;
export const API_USERS_MULTIPLE = `${API_USERS}multiple/`;
export const API_VALIDATE_EMAILS = `${API_USERS}emails/`;
export const API_ORG_CHART = `${API_USERS}organization/`;
export const API_TO_DO = `${API_USERS}to-do/`;
export const API_TEAM_STATS = `${API_USERS}team-stats/`;
export const API_SURVEYS_HISTORY = `${API_USERS}survey-reviews/`;
export const api_user = id => `${API_USERS}${id}/`;
export const api_user_personal_info = id => `${API_USERS}${id}/personal-info/`;
export const api_user_employment_info = id =>
  `${API_USERS}${id}/employment-info/`;
export const api_user_surveys_timeline = id =>
  `${API_USERS}${id}/surveys-timeline/`;
export const api_upload_photo = id => `${API_USERS}${id}/avatar/`;
export const API_USER_NOTES = `user-notes/`;
export const API_MY_PRIVATE_NOTES = `${API_USER_NOTES}private/`;
export const api_user_notes_with_view_permission = id =>
  `${API_USER_NOTES}${id}/users-with-view-permission/`;
export const api_user_notes = id => `users/${id}/notes/`;
export const api_user_reviewed_attributes = userId =>
  `${API_USERS}${userId}/reviewed-attributes/`;
export const api_user_reports_aggregated = (userId, groupBy) =>
  `${API_USERS}${userId}/reports/grouped-by-${groupBy}/`;
export const api_user_reports_comments = userId =>
  `${API_USERS}${userId}/reports/comments/`;
export const api_user_organization = userId => `${API_ORG_CHART}${userId}/`;
export const api_user_one_on_one = userId =>
  `${API_USERS}${userId}/one-on-one/`;
export const api_user_attributes = userId =>
  `${API_USERS}${userId}/attributes/`;
export const api_user_review_cycles = userId => `${API_USERS}${userId}/cycles/`;
export const api_user_review_cycle = (userId, cycleId) =>
  `${API_USERS}${userId}/cycle-results/${cycleId}/`;
export const api_user_review_cycle_open_ended_answers = (userId, cycleId) =>
  `${API_USERS}${userId}/cycle-replies/${cycleId}/`;

// ------------------------------------
// Announcements
// ------------------------------------

export const API_ANNOUNCEMENTS = 'announcements/';
export const API_ANNOUNCEMENTS_CATEGORIES = `${API_ANNOUNCEMENTS}categories/`;
export const api_announcement = announcementId =>
  `${API_ANNOUNCEMENTS}${announcementId}/`;
export const api_announcements_by_category = category =>
  `${API_ANNOUNCEMENTS}by-category/${category}/`;
export const api_announcement_publish = announcementId =>
  `${api_announcement(announcementId)}publish/`;
export const api_announcement_unpublish = announcementId =>
  `${api_announcement(announcementId)}unpublish/`;

// ------------------------------------
// Documents
// ------------------------------------

export const API_DOCUMENT_CATEGORIES = 'document-categories/';
export const API_USER_DOCUMENT_CATEGORIES = 'document-categories/user/';
export const api_document_categories = categoryId =>
  `${API_DOCUMENT_CATEGORIES}${categoryId}/`;
export const API_DOCUMENT_TYPES = 'document-types/';
export const api_document_category_types = categoryId =>
  `${API_DOCUMENT_CATEGORIES}${categoryId}/types/`;
export const API_DOCUMENTS = 'documents/';
export const api_documents = documentId => `${API_DOCUMENTS}${documentId}/`;

//
// Role-Based Access Control (RBAC)
// ------------------------------------

const API_RBAC = 'rbac/';
export const API_RBAC_ROLES = `${API_RBAC}roles/`;
export const API_RBAC_ADDITIONAL_ROLES = `${API_RBAC_ROLES}custom/`;
export const API_RBAC_PERMISSIONS_GROUPED = `${API_RBAC}permissions/grouped/`;
export const API_RBAC_PERMISSIONS_GROUPS_BY_ROLE = `${API_RBAC}roles/grouped-permissions/`;
export const API_RBAC_AUTH_PERMISSIONS = `${API_RBAC}${API_USERS}me/permissions/`;
export const API_RBAC_AUTH_DIRECT_REPORTS = `${API_RBAC}${API_USERS}me/direct-reports/`;
export const API_RBAC_AUTH_INDIRECT_REPORTS = `${API_RBAC}${API_USERS}me/indirect-reports/`;
export const API_RBAC_AUTH_SCOPED_USERS = `${API_RBAC}${API_USERS}me/custom-subordinates/`;
export const api_rbac_role_permissions = roleId =>
  `${API_RBAC_ROLES}${roleId}/permissions/`;
export const api_rbac_user_roles = userId =>
  `${API_RBAC}${API_USERS}${userId}/`;
export const api_rbac_users_scope_groups = userId =>
  `${API_RBAC}${API_USERS}${userId}/subordinate-groups/`;
export const api_rbac_users_scope_group = (userId, scopeId) =>
  `${API_RBAC}${API_USERS}${userId}/subordinate-groups/${scopeId}/`;

// ------------------------------------
// Attributes
// ------------------------------------

export const API_ATTRIBUTES = 'attributes/';
export const API_ATTRIBUTES_BASIC = `${API_ATTRIBUTES}basic/`;
// params: { name: string(attribute name), code: string(short name) }
export const API_UNIQUE_ATTRIBUTE = `${API_ATTRIBUTES}validate/`;
export const api_duplicate_attribute = id =>
  `${API_ATTRIBUTES}${id}/duplicate/`;
export const api_attribute_usage = id => `${API_ATTRIBUTES}${id}/usage/`;
export const api_attribute_questions_usage = id =>
  `${API_ATTRIBUTES}${id}/questions-usage/`;
export const api_attribute = id => `${API_ATTRIBUTES}${id}/`;
export const API_IMPORT_ATTRIBUTES = `${API_ATTRIBUTES}import-fixtures/`;

// ------------------------------------
// Questionnaire
// ------------------------------------

export const API_QUESTIONNAIRES = 'questionnaires/';
export const api_questionnaire = questionnaireId =>
  `${API_QUESTIONNAIRES}${questionnaireId}/`;

// ------------------------------------
// Surveys/Inquiries
// ------------------------------------
export const API_SURVEYS = 'surveys/';
export const API_SURVEY_SUMMARY = `survey-reports/`;
export const API_FILL_SURVEYS = 'fill-surveys/';
export const API_SURVEY_GROUPS = 'survey-groups/';
export const API_SURVEY_GROUPS_BASIC = `${API_SURVEY_GROUPS}basic/`;
export const API_PENDING_SURVEYS = `${API_SURVEYS}pending/`;
export const api_survey_group = groupId => `${API_SURVEY_GROUPS}${groupId}/`;
export const api_survey_group_duplicate = groupId =>
  `${api_survey_group(groupId)}duplicate/`;
export const api_survey = surveyId => `${API_SURVEYS}${surveyId}/`;
export const api_survey_attributes = surveyId =>
  `${API_SURVEYS}${surveyId}/attributes/`;
export const api_survey_questionnaires = surveyId =>
  `${API_SURVEYS}${surveyId}/questionnaires/`;
export const api_survey_questionnaire = (surveyId, questionnaireId) =>
  `${API_SURVEYS}${surveyId}/questionnaires/${questionnaireId}/`;
export const api_survey_questionnaire_responses = (surveyId, questionnaireId) =>
  `${API_SURVEYS}${surveyId}/questionnaires/${questionnaireId}/responses/`;
export const api_survey_questionnaire_summary = (surveyId, questionnaireId) =>
  `${API_SURVEYS}${surveyId}/questionnaires/${questionnaireId}/summary/`;
export const api_survey_reviewers = surveyId =>
  `${API_SURVEYS}${surveyId}/reviewers/`;
export const api_review_participants_info = (surveyId, attributeId) =>
  `${API_SURVEYS}${surveyId}/${API_ATTRIBUTES}${attributeId}/`;
export const api_review_results = (surveyId, attributeId) =>
  `${API_SURVEYS}${surveyId}/${API_ATTRIBUTES}${attributeId}/answers/`;
export const api_text_reply_review_results = (surveyId, attributeId) =>
  `${API_SURVEYS}${surveyId}/${API_ATTRIBUTES}${attributeId}/replies/`;
export const api_enps_review_results = (surveyId, attributeId) =>
  `${API_SURVEYS}${surveyId}/${API_ATTRIBUTES}${attributeId}/enps-answers/`;
export const api_enps_review_replies = (surveyId, attributeId) =>
  `${API_SURVEYS}${surveyId}/${API_ATTRIBUTES}${attributeId}/enps-replies/`;
export const api_review_feedback = (surveyId, attributeId) =>
  `${API_SURVEYS}${surveyId}/${API_ATTRIBUTES}${attributeId}/comments/`;
export const api_survey_duplicate = surveyId =>
  `${API_SURVEYS}${surveyId}/duplicate/`;
export const api_get_survey_tracking_by_id = id =>
  `${API_SURVEYS}${id}/tracking-token/`;
export const api_survey_send_reminder = surveyId =>
  `${API_SURVEYS}${surveyId}/remind/`;
export const api_survey_reopen = surveyId => `${API_SURVEYS}${surveyId}/open/`;
export const api_fill_survey = token => `${API_FILL_SURVEYS}${token}/`;
export const api_survey_history = token =>
  `${API_FILL_SURVEYS}${token}/archive/`;
export const api_fill_attribute_review = (token, id) =>
  `${api_fill_survey(token)}attributes/${id}/`;
export const api_fill_questionnaire_review = (token, id) =>
  `${api_fill_survey(token)}questionnaires/${id}/`;
export const api_attribute_review_history = (token, id) =>
  `${api_fill_survey(token)}archive/attributes/${id}/`;
export const api_questionnaire_review_history = (token, id) =>
  `${api_fill_survey(token)}archive/questionnaires/${id}/`;
export const api_answer_on_attribute_question = token =>
  `${api_fill_survey(token)}answers/`;
export const api_answer_on_questionnaire_question = token =>
  `${api_fill_survey(token)}questionnaire-responses/`;
export const api_answer_on_text_reply_question = token =>
  `${api_fill_survey(token)}replies/`;
export const api_finish_review = token => `${api_fill_survey(token)}finish/`;
export const api_survey_export = surveyId =>
  `${API_SURVEYS}${surveyId}/export/`;
export const api_review_score_per_reviewer = (surveyId, attributeId) =>
  `${API_SURVEYS}${surveyId}/${API_ATTRIBUTES}${attributeId}/score-per-reviewer/`;
export const api_survey_summary_report = surveyId =>
  `${API_SURVEYS}${surveyId}/reports/`;
export const api_review_score_per_subject = (surveyId, attributeId) =>
  `${API_SURVEYS}${surveyId}/${API_ATTRIBUTES}${attributeId}/score-per-subject/`;
export const api_survey_activate = surveyId =>
  `${API_SURVEYS}${surveyId}/activate/`;
export const api_survey_group_items_reorder = groupId =>
  `${API_SURVEY_GROUPS}${groupId}/ordering/`;
export const api_survey_summary = reportId =>
  `${API_SURVEY_SUMMARY}${reportId}/`;
export const api_survey_summary_shared_with = reportId =>
  `${API_SURVEY_SUMMARY}${reportId}/shared-to/`;
export const api_survey_summary_share = reportId =>
  `${API_SURVEY_SUMMARY}${reportId}/share/`;

// ------------------------------------
// Cycles
// ------------------------------------

export const API_CYCLES = 'cycles/';
export const api_cycle = cycleId => `${API_CYCLES}${cycleId}/`;
export const api_cycle_reviews = cycleId => `${API_CYCLES}${cycleId}/surveys/`;
export const api_cycle_timeline_stats = cycleId =>
  `${API_CYCLES}${cycleId}/timeline-stats/`;
export const api_cycle_reviewed_users = cycleId =>
  `${API_CYCLES}${cycleId}/users/`;
export const api_cycle_user_reviewers = (cycleId, userId) =>
  `${API_CYCLES}${cycleId}/reviewers/${userId}/`;
export const api_cycle_steps = cycleId => `${API_CYCLES}${cycleId}/steps/`;
export const api_cycle_step = (cycleId, stepId) =>
  `${API_CYCLES}${cycleId}/steps/${stepId}/`;

// ------------------------------------
// Action Plans
// ------------------------------------

export const API_ACTION_PLANS = 'plans/';
export const API_ACTION_PLANS_EXPORT = `${API_ACTION_PLANS}export/`;
export const API_PLANS_BASIC = `${API_ACTION_PLANS}basic/`;
export const API_ACTION_PLANS_ME = `${API_ACTION_PLANS}me-as-subject/`;
export const API_ACTION_PLANS_ME_CREATED_BY_ME = `${API_ACTION_PLANS}me-as-creator/`;
export const API_ACTION_PLANS_FROM_MY_DIRECT_REPORTS = `${API_ACTION_PLANS}reports-as-subjects/`;
export const API_ACTION_PLANS_PROPOSAL = `${API_ACTION_PLANS}propose/`;
export const api_action_plan_tasks = id => `${API_ACTION_PLANS}${id}/tasks/`;
export const api_action_plans_with_view_permission = id =>
  `${API_ACTION_PLANS}${id}/users-with-view-permission/`;
export const api_user_action_plans = userId =>
  `${API_USERS}${userId}/${API_ACTION_PLANS}`;
export const api_action_plan = id => `${API_ACTION_PLANS}${id}/`;
export const api_action_plan_tasks_status = (id, taskId) =>
  `${api_action_plan_tasks(id)}${taskId}/status-toggle/`;
export const api_action_plan_comment = id => `${api_action_plan(id)}comment/`;
export const api_action_plan_comment_update = (id, commentId) =>
  `${api_action_plan_comment(id)}${commentId}/`;

// ------------------------------------
// Reports
// ------------------------------------

const API_REPORTS = 'reports/';
export const API_MEASURED_ATTRIBUTES = `${API_REPORTS}attribute-usage/`;
export const API_ATTRIBUTES_SCORE_DISTRIBUTION = `${API_REPORTS}attr-score-distribution/`;
export const API_ATTRIBUTES_USER_SCORES = `${API_REPORTS}attr-score-users/`;
export const API_COMPARE_REPORTS_REVIEWED_ATTRIBUTES =
  'users/reports/reviewed-attributes/';
export const API_COMPARE_REPORTS_USERS_BY_ATTRIBUTES =
  'users/reports/users-by-attributes/';
export const API_REPORT_ATTRIBUTE_ANSWERS = `${API_REPORTS}attributes/answers/`;
export const API_REPORT_ATTRIBUTE_REPLIES = `${API_REPORTS}attributes/replies/`;
export const API_REPORT_ATTRIBUTE_FEEDBACK = `${API_REPORTS}attributes/comments/`;
export const API_REPORT_ATTRIBUTE_TIMELINE = `${API_REPORTS}attributes/surveys-timeline/`;
export const API_REPORT_ATTRIBUTE_SCORE = `${API_REPORTS}attributes/score/`;
export const API_REPORT_USER_COMPARE = `${API_REPORTS}profiles/`;
export const API_HEADCOUNT = `${API_REPORTS}head-count/`;
export const API_HEADCOUNT_GENDER = `${API_REPORTS}head-count/gender-timeline/`;
export const API_HEADCOUNT_AGE = `${API_REPORTS}head-count/age-timeline/`;
export const API_HEADCOUNT_LEVELS = `${API_REPORTS}head-count/levels/`;
export const API_HEADCOUNT_DEPARTMENTS = `${API_REPORTS}head-count/departments/`;
export const API_ABSENCE_REPORT_COMPANY_STATS =
  'absence-reports/company-stats/';
export const API_ABSENCE_REPORT_USER_STATS = 'absence-reports/user-stats/';
export const API_TIME_TO_HIRE_BY_DEPARTMENT =
  'recruitment-reports/time-to-hire/by-department/';
export const API_TIME_TO_HIRE_BY_RECRUITER =
  'recruitment-reports/time-to-hire/by-recruiter/';
export const API_TIME_TO_HIRE_BY_JOB =
  'recruitment-reports/time-to-hire/by-job/';
export const API_TIME_TO_HIRE_STATISTICS =
  'recruitment-reports/time-to-hire/statistics/';

// ------------------------------------
// OneOnOne
// ------------------------------------

export const API_ONE_ON_ONE = 'one-on-one/';
export const API_ONE_ON_ONE_ME = `${API_ONE_ON_ONE}me-as-subject/`;
export const API_ONE_ON_ONE_ORGANIZED_BY_ME = `${API_ONE_ON_ONE}me-as-moderator/`;
export const API_ONE_ON_ONE_FROM_MY_DIRECT_REPORTS = `${API_ONE_ON_ONE}reports-as-subjects/`;
export const API_ONE_ON_ONE_TOPICS = `${API_ONE_ON_ONE}topics/`;
export const API_ONE_ON_ONE_USER_REQUEST = `${API_ONE_ON_ONE}requests/`;
export const API_ONE_ON_ONE_MODERATOR_REQUEST = `${API_ONE_ON_ONE}requested-for/`;
export const API_ONE_ON_ONE_REPORT = `${API_REPORTS}1-1-history/`;
export const API_ONE_ONE_ONE_REPORT_PARTIALS = `${API_REPORTS}1-1-partials/`;
export const api_one_on_one_record = id => `${API_ONE_ON_ONE}${id}/`;
export const api_one_on_one_record_agenda = id =>
  `${API_ONE_ON_ONE}${id}/agenda/`;
export const api_one_on_one_topic = id => `${API_ONE_ON_ONE_TOPICS}${id}/`;
export const api_one_on_one_comments = id =>
  `${api_one_on_one_record(id)}comments/`;
export const api_one_on_one_comment_update = (id, commentId) =>
  `${api_one_on_one_comments(id)}${commentId}/`;
export const api_one_on_one_tasks = id => `${API_ONE_ON_ONE}${id}/tasks/`;
export const api_one_on_one_tasks_status = (id, taskId) =>
  `${api_one_on_one_tasks(id)}${taskId}/status-toggle/`;
export const api_one_on_one_with_view_permission = id =>
  `${API_ONE_ON_ONE}${id}/users-with-view-permission/`;
export const api_one_on_one_with_notes_view_permission = id =>
  `${API_ONE_ON_ONE}${id}/users-with-notes-view-permission/`;

// ------------------------------------
// Positions
// ------------------------------------

export const API_POSITIONS = 'positions/';
// params: { name: string }
export const API_UNIQUE_POSITION = `${API_POSITIONS}unique/`;
export const api_position = id => `${API_POSITIONS}${id}/`;
export const API_IMPORT_POSITIONS = `${API_POSITIONS}import-fixtures/`;

// ------------------------------------
// Tags, Tag Categories
// ------------------------------------

export const API_TAGS = 'tags/';
export const API_TAGS_MULTIPLE = `${API_TAGS}multiple/`;
export const API_TAG_CATEGORIES = 'tag-categories/';
export const API_TAGS_IN_USE = `${API_TAGS}in-use/`;
export const API_TAG_CATEGORIES_REORDER = `${API_TAG_CATEGORIES}ordering/`;
export const api_page_tag_categories = pageId =>
  `${API_TAG_CATEGORIES}${pageId}/placements/`;
export const api_tag_category = categoryId =>
  `${API_TAG_CATEGORIES}${categoryId}/`;
export const api_tagged_users = categoryId =>
  `${API_TAG_CATEGORIES}${categoryId}/tagged-users/`;
export const api_assign_users_to_tag = tagId =>
  `${API_TAGS}${tagId}/assign-users/`;

// ------------------------------------
// Positions
// ------------------------------------

export const API_PRESETS = 'presets/';
export const api_preset = presetId => `${API_PRESETS}${presetId}/`;

// ------------------------------------
// eLearning
// ------------------------------------

export const API_COURSES = 'courses/';
export const api_course = courseId => `${API_COURSES}${courseId}/`;
export const api_course_users = courseId => `${API_COURSES}${courseId}/users/`;
export const api_user_courses = userId => `${API_USERS}${userId}/courses/`;
export const api_course_users_enroll = courseId =>
  `${API_COURSES}${courseId}/enroll/`;
export const api_course_users_disenroll = courseId =>
  `${API_COURSES}${courseId}/disenroll/`;
export const API_MY_COURSES = `${API_COURSES}me/`;
export const API_IMPORT_COURSES = `${API_COURSES}import-fixtures/`;
export const API_UNIQUE_COURSE_TITLE = `${API_COURSES}exists/`;

// ------------------------------------
// Subscription
// ------------------------------------

export const API_SUBSCRIPTION = 'subscriptions/';
export const API_CUSTOMER_PORTAL = 'subscriptions/customer-portal/';

// ------------------------------------
// Company Overview
// ------------------------------------

export const API_COMPANY = 'company/';
export const API_COMPANY_METRICS = `${API_COMPANY}metrics/`;
export const API_COMPANY_ONE_ON_ONE_STATS = `${API_COMPANY}stats/1-1/`;
export const API_COMPANY_ACTION_PLANS_STATS = `${API_COMPANY}stats/plans/`;
export const API_COMPANY_COURSES_STATS = `${API_COMPANY}stats/courses/`;
export const api_company_no_one_on_one = managerId =>
  `${API_COMPANY}${managerId}/without-1-1/`;
export const api_company_low_impressed = managerId =>
  `${API_COMPANY}${managerId}/low-impressed/`;

// ------------------------------------
// Leveling
// ------------------------------------

export const API_FRAMEWORKS = 'frameworks/';
export const API_UNIQUE_FRAMEWORK = `${API_FRAMEWORKS}exists/`;
export const api_frameworks = id => `${API_FRAMEWORKS}${id}/`;
export const api_framework_duplicate = frameworkId =>
  `${api_frameworks(frameworkId)}duplicate/`;
export const API_FRAMEWORK_ITEMS_REORDER = `${API_FRAMEWORKS}ordering/`;
export const api_leveling_add_template = `${API_FRAMEWORKS}add-template/`;
export const api_tracks_reorder = id => `${api_frameworks(id)}ordering/`;
export const API_TRACKS = 'tracks/';
export const api_tracks = id => `${API_TRACKS}${id}/`;
export const api_levels_reorder = id => `${api_tracks(id)}ordering/`;
export const api_track_duplicate = trackId =>
  `${api_tracks(trackId)}duplicate/`;
export const api_track_move = id => `${api_tracks(id)}move/`;
export const API_LEVELS = 'levels/';
export const api_levels = id => `${API_LEVELS}${id}/`;
export const api_levels_users = id => `${api_levels(id)}users/`;
export const API_LEVELS_SALARIES = `${API_LEVELS}update-salary/`;
export const api_level_duplicate = levelId =>
  `${api_levels(levelId)}duplicate/`;
export const api_level_move = id => `${api_levels(id)}move/`;

// ------------------------------------
// Slack
// ------------------------------------

export const API_SLACK_STATUS = 'slack/';
export const API_SLACK_DISCONNECT = 'slack/disconnect/';
export const API_SLACK_SYNC_USERS = 'slack/sync-users/';

// ------------------------------------
// Tasks
// ------------------------------------

const API_TASKS = 'tasks/';
export const API_MY_TASKS = `${API_TASKS}my/`;
export const api_task_completion = taskId =>
  `${API_TASKS}${taskId}/status-toggle/`;

// ------------------------------------
// Team notifications
// ------------------------------------

export const API_NOTIFICATIONS = 'notifications/';
export const API_NOTIFICATIONS_COUNT = `${API_NOTIFICATIONS}count/`;
export const API_CLEAR_NOTIFICATIONS = `${API_NOTIFICATIONS}clear/`;
export const api_clear_notification = notificationId =>
  `${API_NOTIFICATIONS}${notificationId}/clear/`;

// ------------------------------------
// Absences
// ------------------------------------

export const API_ABSENCE_SETS = 'absence-sets/';
export const API_ABSENCE = 'absence-types/';
export const API_ABSENCE_EXTENSIONS = 'absence-extensions/';
export const API_ABSENCE_REQUESTS = 'absence-requests/';
export const API_UNIQUE_ABSENCE_SET = `${API_ABSENCE_SETS}exists/`;
export const API_HOLIDAYS = 'holidays/';
export const API_ABSENCE_REQUESTS_OWN = `${API_ABSENCE_REQUESTS}request-own/`;
export const API_ABSENCE_ADJUSTMENT = 'absence-adjustment/';
export const API_ABSENCE_USERS_WITH_ABSENCES = '/absence-user/managable-users/';
export const api_existing_holiday_dates = setId =>
  `${API_ABSENCE_SETS}${setId}/existing-dates/`;
export const API_ABSENCE_CALENDAR = `absence-user/absence-calendar/`;
export const api_absence_breakdown = userId =>
  `absence-user/${userId}/absence-breakdown/`;
export const api_absence_set = setId => `${API_ABSENCE_SETS}${setId}/`;
export const api_absence_set_duplicate = setId =>
  `${API_ABSENCE_SETS}${setId}/duplicate/`;
export const api_absence_set_users = setId =>
  `${API_ABSENCE_SETS}${setId}/users/`;
export const api_absence_set_and_absence_add_users = setId =>
  `${API_ABSENCE_SETS}${setId}/users/add-to-set-and-types/`;
export const api_absence = absenceId => `${API_ABSENCE}${absenceId}/`;
export const api_absence_report_template = absenceId =>
  `${api_absence(absenceId)}pdf-report-template/`;
export const api_absence_users = absenceId =>
  `${API_ABSENCE}${absenceId}/users/`;
export const api_absence_extension = extensionId =>
  `${API_ABSENCE_EXTENSIONS}${extensionId}/`;
export const api_absence_extension_users = extensionId =>
  `${API_ABSENCE_EXTENSIONS}${extensionId}/users/`;
export const api_absence_request = requestId =>
  `${API_ABSENCE_REQUESTS}${requestId}/`;
export const api_absence_request_own = requestId =>
  `${API_ABSENCE_REQUESTS}${requestId}/edit-own/`;
export const api_absence_request_delete_own = requestId =>
  `${API_ABSENCE_REQUESTS}${requestId}/delete-own/`;
export const api_absence_request_status = requestId =>
  `${API_ABSENCE_REQUESTS}${requestId}/confirm/`;
export const api_absence_request_actions = requestId =>
  `${API_ABSENCE_REQUESTS}${requestId}/actions/`;
export const api_holiday = holidayId => `${API_HOLIDAYS}${holidayId}/`;
export const api_user_absences = userId => `absence-user/${userId}/absences/`;
export const api_user_absence_timeline = userId =>
  `absence-user/${userId}/timeline/`;
export const api_user_absence_requests = userId =>
  `absence-user/${userId}/absence-requests/`;
export const api_user_absence_upcoming_time_off = userId =>
  `absence-user/${userId}/upcoming-time-off/`;
export const api_user_absence_available_days = userId =>
  `absence-user/${userId}/number-of-days/`;

// ------------------------------------
// Recruitment
// ------------------------------------

export const API_JOBS = 'jobs/';
export const api_job = id => `${API_JOBS}${id}/`;
export const API_JOBS_BASIC = `${API_JOBS}all/`;
export const API_JOBS_ARCHIVED = `${API_JOBS}archived/`;
export const api_job_public = id => `${api_job(id)}visible-public/`;
export const api_jobs_public = public_slug => `${API_JOBS}pub/${public_slug}/`;
export const api_jobs_public_apply = public_slug =>
  `${API_JOBS}pub/${public_slug}/apply/`;
export const api_candidates_in_job = id => `${api_job(id)}candidates/`;
export const api_job_archive = id => `${api_job(id)}archive/`;
export const api_job_unarchive = id => `${api_job(id)}unarchive/`;
export const api_job_duplicate = id => `${api_job(id)}duplicate/`;
export const api_job_recruitment_steps = id =>
  `${api_job(id)}recruitment-steps/`;
export const api_job_team = id => `${API_JOBS}${id}/hiring-team/`;
export const api_candidate_reviews = id => `${api_job(id)}reviews/`;
export const api_candidate_review = (jobId, reviewId) =>
  `${api_job(jobId)}reviews/${reviewId}/`;
export const api_candidate_comments = id => `${api_job(id)}notes/`;
export const api_candidate_comment = (jobId, noteId) =>
  `${api_job(jobId)}notes/${noteId}/`;
export const api_candidate_emails = id => `${api_job(id)}messages/`;
export const api_candidate_timeline = (jobId, candidateId) =>
  `${api_job(jobId)}candidate-timeline/${candidateId}/`;

export const API_CANDIDATES = 'candidates/';
export const api_candidate = id => `${API_CANDIDATES}${id}/`;
export const API_VALIDATE_CANDIDATES_EMAILS = `${API_CANDIDATES}emails/`;
export const API_CANDIDATES_ALL = `${API_CANDIDATES}all/`;
export const api_candidates_in_jobs = id => `${api_candidate(id)}jobs/`;
export const API_CANDIDATES_FROM_CV = `${API_CANDIDATES}from-cv/`;

const API_SELECTION_STEPS = 'selection-steps/';
export const api_add_candidate_to_step = (stepId, candidateId) =>
  `${API_SELECTION_STEPS}${stepId}/move-candidate/${candidateId}/`;
export const api_selection_step_candidate = (stepId, candidateId) =>
  `${API_SELECTION_STEPS}${stepId}/candidate/${candidateId}/`;
export const api_candidate_disqualify = (stepId, candidateId) =>
  `${API_SELECTION_STEPS}${stepId}/disqualify/${candidateId}/`;
export const api_candidate_qualify = (stepId, candidateId) =>
  `${API_SELECTION_STEPS}${stepId}/qualify/${candidateId}/`;

// ------------------------------------
// Divisions and departments
// ------------------------------------

export const API_DIVISIONS = 'divisions/';
export const API_UNIQUE_DIVISION = `${API_DIVISIONS}exists/`;
export const api_division = id => `${API_DIVISIONS}${id}/`;
export const api_division_duplicate = divisionId =>
  `${api_division(divisionId)}duplicate/`;
export const API_DIVISION_ITEMS_REORDER = `${API_DIVISIONS}ordering/`;
export const api_departments_reorder = id => `${api_division(id)}ordering/`;
export const API_DEPARTMENTS = 'departments/';
export const api_department = id => `${API_DEPARTMENTS}${id}/`;
export const api_department_duplicate = departmentId =>
  `${api_department(departmentId)}duplicate/`;
export const api_departments_users = id => `${api_department(id)}users/`;

// ------------------------------------
// Succession
// ------------------------------------

const API_SUCCESSION = 'succession/';
export const API_SUCCESSION_SETTINGS = `${API_SUCCESSION}settings/`;
export const API_SUCCESSION_KEY_JOBS = `${API_SUCCESSION}key-jobs/`;
export const api_succession_key_job = id => `${API_SUCCESSION_KEY_JOBS}${id}/`;

export const API_SUCCESSION_JOB_FAMILIES = `${API_SUCCESSION}job-families/`;
export const API_SUCCESSION_READINESS = `${API_SUCCESSION}readiness/`;
export const API_SUCCESSION_CRITICALITY = `${API_SUCCESSION}criticality/`;
export const API_SUCCESSION_REMOVAL_REASONS = `${API_SUCCESSION}removal-reasons/`;
export const api_succession_catalog_item = (base, id) => `${base}${id}/`;
export const api_succession_catalog_ordering = base => `${base}ordering/`;
export const api_succession_catalog_deactivate = (base, id) =>
  `${base}${id}/deactivate/`;

export const API_SUCCESSION_SUCCESSORS = `${API_SUCCESSION}successors/`;
export const api_succession_successor = id =>
  `${API_SUCCESSION_SUCCESSORS}${id}/`;
export const api_succession_successor_remove = id =>
  `${API_SUCCESSION_SUCCESSORS}${id}/remove/`;
export const API_SUCCESSION_SUCCESSORS_REORDER = `${API_SUCCESSION_SUCCESSORS}reorder/`;

export const API_SUCCESSION_TALENT_POOLS = `${API_SUCCESSION}talent-pools/`;
export const api_succession_talent_pool = id =>
  `${API_SUCCESSION_TALENT_POOLS}${id}/`;
export const api_succession_talent_pool_archive = id =>
  `${api_succession_talent_pool(id)}archive/`;
export const api_succession_talent_pool_members = id =>
  `${api_succession_talent_pool(id)}members/`;
export const api_succession_talent_pool_member = (poolId, memberId) =>
  `${api_succession_talent_pool_members(poolId)}${memberId}/`;
export const api_succession_talent_pool_changelog = id =>
  `${api_succession_talent_pool(id)}change-log/`;

export const api_succession_key_job_change_log = id =>
  `${API_SUCCESSION_KEY_JOBS}${id}/change-log/`;
export const api_succession_profile = userId =>
  `${API_SUCCESSION}profile/${userId}/`;

// ------------------------------------
// Rest
// ------------------------------------

export const API_ORGANIZATION_SETTINGS = 'config/';
export const API_RELEASE_NOTES = 'config/releases/';
export const API_DEMO_DATA = 'config/demo-data/';
